import { defineStore } from 'pinia';
import { RouteRecordRaw } from 'vue-router';
import { asyncRoutes, constantRoutes, catchAllRoutes } from '@/router';
import { intersection } from '@/utils/index';

/**
 * 获取用户有权限的路由
 * @param routes
 * @param menus
 */
export function filterAsyncRoutes(routes: RouteRecordRaw[], authCodes: Array<any>): RouteRecordRaw[] {
  const result: Array<RouteRecordRaw> = [];

  routes.forEach((route: RouteRecordRaw) => {
    const routeAuthCodes: string[] | any = route?.meta?.authCodes || [];
    const matchedCodes = intersection(authCodes, routeAuthCodes);
    if (matchedCodes.length > 0) {
      if (route.children) {
        route.children = filterAsyncRoutes(route.children, authCodes);
      }
      result.push(route);
    }
  });

  return result;
}

type State = {
  permissionRoutes: TypeObject[],
  accessedRoutes: TypeObject[]
  newMenu: TypeObject[]
}
function mapMenuList(routes: any){
  // console.log('mapMenuList----',routes)
  let arr: { children?: any[]; name: any; icon: any; id: any; }[] = []
  routes.forEach((item: any) => {
    if (!item.meta.hidden) {
      let value = {
        name: item.meta.title || '--',
        icon: item.meta.icon,
        id: item.path,
      }
      if (item.children && item.children.length) {
        arr.push({
          ...value,
          children: mapMenuList(item.children),
        })
      } else {
        arr.push(value)
      }
    }
  });
  return arr
}

export const usePermissionStore = defineStore('_permission', {
  state: (): State => ({
    permissionRoutes: [], // 最终要展示到菜单的路由列表
    accessedRoutes: [], // 匹配权限的菜单列表
    newMenu: [], // 新菜单
  }),
  actions: {
    generateRoutes(authCodes: Array<TypeObject>): Promise<TypeObject> {
      return new Promise((resolve) => {
        const accessedRoutes = filterAsyncRoutes(asyncRoutes, authCodes);

        this.accessedRoutes = accessedRoutes;
        this.permissionRoutes = [...constantRoutes, ...accessedRoutes, ...catchAllRoutes];
        this.newMenu = mapMenuList(this.accessedRoutes);
        // console.log('this.newMenu---',this.newMenu)
        // console.log('accessedRoutes---1',this.accessedRoutes)

        resolve({
          accessedRoutes,
          permissionRoutes: this.permissionRoutes,
          newMenu: this.permissionRoutes,
        });
      });
    },
  },
});
